import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const links = [
  { id: "tjenester", label: "Tjenester", testId: "nav-link-services" },
  { id: "slik-fungerer-det", label: "Slik fungerer det", testId: "nav-link-how-it-works" },
  { id: "priser", label: "Priser", testId: "nav-link-pricing" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchor = (e, id) => {
    e.preventDefault();
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "backdrop-blur-xl bg-white/85 border-b border-black/5"
          : "bg-white/0 border-b border-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <a
            href="#topp"
            onClick={(e) => handleAnchor(e, "topp")}
            className="flex items-center"
            data-testid="nav-logo"
            aria-label="Apple Doctor"
          >
            <img
              src="/apple-doctor-logo.jpeg"
              alt="Apple Doctor"
              className="h-9 sm:h-10 w-auto object-contain"
            />
          </a>

          <nav className="hidden md:flex items-center gap-9">
            {links.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={(e) => handleAnchor(e, l.id)}
                className="text-sm font-medium text-[#1D1D1F] hover:text-[#1D3557] transition-colors"
                data-testid={l.testId}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:block">
            <Button
              onClick={(e) => handleAnchor(e, "kontakt")}
              className="rounded-full bg-[#1D3557] hover:bg-[#16293F] text-white px-5 h-9 text-sm font-medium transition-colors"
              data-testid="nav-cta-contact"
            >
              Kontakt oss
            </Button>
          </div>

          <button
            className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-full text-[#1D1D1F] hover:bg-black/5"
            onClick={() => setOpen((v) => !v)}
            aria-label="Meny"
            data-testid="nav-mobile-toggle"
          >
            {open ? <X size={20} strokeWidth={1.5} /> : <Menu size={20} strokeWidth={1.5} />}
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-4 pt-2 border-t border-black/5" data-testid="nav-mobile-menu">
            <div className="flex flex-col gap-1">
              {links.map((l) => (
                <a
                  key={l.id}
                  href={`#${l.id}`}
                  onClick={(e) => handleAnchor(e, l.id)}
                  className="px-2 py-3 text-base text-[#1D1D1F] hover:bg-black/5 rounded-lg"
                  data-testid={`${l.testId}-mobile`}
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#kontakt"
                onClick={(e) => handleAnchor(e, "kontakt")}
                className="mt-2 inline-flex items-center justify-center rounded-full bg-[#1D3557] hover:bg-[#16293F] text-white px-5 h-11 text-sm font-medium transition-colors"
                data-testid="nav-cta-contact-mobile"
              >
                Kontakt oss
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
